<script setup>
import { computedAsync, get } from '@vueuse/core'
import qrSVG from '@/assets/images/common/icon.logo.qr.svg?url'

const props = defineProps({
  url: {
    type: String,
    default: '',
  },
  logo: {
    type: String,
    default: '',
  },
  hasLogo: {
    type: Boolean,
    default: false,
  },
  logoClass: {
    type: String,
    default: '',
  },
})
const toDataURL = computedAsync(async () => {
  const { default: qr } = await import('qrcode')
  return async url => await qr.toDataURL(url, { margin: 0 })
}, null)
const dataURL = computedAsync(async () => {
  return await get(toDataURL)?.(props.url)
}, null)
function getImage() {
  return props.logo || qrSVG
}
</script>

<template>
  <div class="relative flex items-center justify-center bg-white">
    <img
      v-if="dataURL"
      :src="dataURL"
      class="w-full"
      crossorigin="anonymous"
    >
    <img
      v-if="logo || hasLogo"
      crossorigin="anonymous"
      class="absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
      :class="logoClass"
      :src="getImage()"
    >
  </div>
</template>
